import React, { useMemo, useRef, useState } from "react";
import { BsFiletypePdf } from "react-icons/bs";
import { Search } from "lucide-react";
import PortalModal from "../PortalModal";
import img from "../../Assets/Logos/profile3.jpg";
import { QRCodeCanvas } from "qrcode.react";
import logo from "../../Assets/Logos/ashoklogo.png";
import vote from "../../Assets/Logos/vote.png";
import html2pdf from "html2pdf.js";
import { toast } from "react-toastify";
import axios from "axios";
import { useEffect } from "react";
import VoterIDCard from "../../Screens/Common/VoterIDCard";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { useAssets } from "../../Context/AssetsContext";

const REACT_APP_CLOUDINARY_UPLOAD_URL =
  process.env.REACT_APP_CLOUDINARY_UPLOAD_URL;
const REACT_APP_CLOUDINARY_UPLOAD_PRESET =
  process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET;

export default function VoterCard() {
  const { assetsReady, assets } = useAssets();
  const [voterId, setVoterId] = useState("");
  const [isDownloading, setIsDownloading] = useState(false);
  const [dob, setDob] = useState("");
  // Get current user and their servicePrices
  // const currentUser = JSON.parse(localStorage.getItem("user") || "{}");
  // const voterIdPrice = currentUser?.servicePrices?.voterId;

  const [voterIdPrice, setVoterIdPrice] = useState(null);
  const [voterIdAccess, setVoterIdAccess] = useState(false);
  const [name, setName] = useState("");
  const [fatherName, setFatherName] = useState("");
  const [address, setAddress] = useState("");
  const [selectedCard, setSelectedCard] = useState(null);
  const [history, setHistory] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;
  const printRef = useRef();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const [voterData, setVoterData] = useState(null);
  const [showCard, setShowCard] = useState(false);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [filters, setFilters] = useState({
    search: "",
    status: "",
    fromDate: "",
    toDate: "",
  });
  const [filteredHistory, setFilteredHistory] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [uploadedImageUrl, setUploadedImageUrl] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const cardRef = useRef();
  const fetchPriceData = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/services/access-check `,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        },
      );
      setVoterIdAccess(response.data?.serviceAccess.includes("voterId"));
      setVoterIdPrice(response.data?.servicePrices?.voterId);
    } catch (e) {
      console.error("Error fetching data:", e);
    }
  };
  // const mockVoterData = {
  //   client_id: "voter_hvTAjyKoGlubpyDctMMT",
  //   input_voter_id: "TRY1234567",
  //   epic_no: "TRY1234567",
  //   gender: "M",
  //   state: "Rajasthan",
  //   name: "VISHAL",
  //   relation_name: "RAJENDRA",
  //   relation_type: "FTHR",
  //   house_no: null,
  //   dob: null,
  //   age: "22",
  //   area: "ABCD",
  //   district: "Dausa",
  //   additional_check: [],
  //   multiple: false,
  //   last_update: null,
  //   assembly_constituency: "XXXXX",
  //   assembly_constituency_number: "00",
  //   polling_station: "Government Upper Primary School",
  //   part_number: "000",
  //   part_name: "ABCD",
  //   slno_inpart: "000",
  //   ps_lat_long: "",
  //   rln_name_v1: "राजेंद्र",
  //   rln_name_v2: "",
  //   rln_name_v3: "",
  //   section_no: "2",
  //   name_v1: "विशाल",
  //   name_v2: "विशाल",
  //   name_v3: "",
  //   parliamentary_name: "ABCD",
  //   parliamentary_number: "11",
  //   st_code: "S20",
  //   parliamentary_constituency: "Dausa",
  //   id: "6940610_TRY1234567_S20",
  // };

  const applyFilters = () => {
    let result = [...history];

    // Apply search filter
    if (filters.search) {
      const searchTerm = filters.search.toLowerCase();
      result = result.filter(
        (item) =>
          item.voterId.toLowerCase().includes(searchTerm) ||
          (item.name && item.name.toLowerCase().includes(searchTerm)),
      );
    }

    // Apply status filter
    if (filters.status) {
      result = result.filter((item) => item.status === filters.status);
    }

    // Apply date range filter
    if (filters.fromDate) {
      const fromDate = new Date(filters.fromDate);
      result = result.filter((item) => new Date(item.date) >= fromDate);
    }

    if (filters.toDate) {
      const toDate = new Date(filters.toDate);
      toDate.setHours(23, 59, 59, 999); // Include entire day
      result = result.filter((item) => new Date(item.date) <= toDate);
    }

    setFilteredHistory(result);
    setCurrentPage(1); // Reset to first page when filters change
  };

  const clearFilters = () => {
    setFilters({
      search: "",
      status: "",
      fromDate: "",
      toDate: "",
    });
    setFilteredHistory([...history]);
  };

  const fetchData = async () => {
    try {
      setIsLoading(true);
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/services/get-document-records?service=voter-id`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        },
      );

      // Map the API response to match your frontend's expected structure
      const historyData = response.data.map((item, index) => ({
        date: new Date(item.createdAt).toLocaleString(),
        slNo: `${index + 1}`.padStart(3, "0"),
        voterId: item.idNumber,
        status: item.status.charAt(0).toUpperCase() + item.status.slice(1),
        error: item.status === "failed" ? "Verification failed" : "",
        createdAt: new Date(item.createdAt),
      }));

      setHistory(historyData);
      setFilteredHistory(historyData);
    } catch (error) {
      console.error("Error fetching data:", error);
      toast.error("Failed to fetch history");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    applyFilters();
  }, [filters]);

  useEffect(() => {
    fetchData();
    fetchPriceData();
  }, []);

  //! Siddhant Bhai code
  // const handleSubmit = () => {
  //   if (!voterId.trim()) {
  //     toast.error("Please enter Voter ID number");
  //     return;
  //   }

  //   // Show confirmation modal instead of making API call directly
  //   setShowConfirmationModal(true);
  // };

  const proceedWithApiCall = async () => {
    if (!voterId.trim()) {
      toast.error("Please enter Voter ID number");
      return;
    }
    if (!voterIdAccess) {
      toast.error("You don't have access to this service");
      return;
    }
    setShowConfirmationModal(false);

    setIsLoading(true);
    setError("");
    setVoterData(null);

    // Bypass API call - using mock data
    //   const response = {
    //     data: {
    //       success: true,
    //       message: "Voter ID verification successful (using mock data)",
    //       data: {
    //         ...mockVoterData,
    //         // input_voter_id: voterId, // Use the entered voter ID
    //         // name: "VISHAL KUMAR", // Example name
    //         // fatherName: "RAJENDRA SINGH", // Example father's name
    //         // address:  response.data.data.house_no+" "+response.data.data.area+" "+response.data.data.district+" "+response.data.data.state || "N/A", // Example address
    //         // photoUrl: img // Using the imported image as photo
    //       },
    //     },
    //   };

    //   setVoterData(response.data.data);
    //   setShowCard(true);

    //   // Add to history
    //   const newEntry = {
    //     date: new Date().toLocaleString(),
    //     voterId: response.data.data.input_voter_id,
    //     name: response.data.data.name || "N/A",
    //     dob: response.data.data.dob || "N/A",
    //     status: "Success",
    //   };
    //   setHistory((prev) => [newEntry, ...prev]);

    //   toast.success("Voter data fetched successfully (using mock data)");

    //   // Set the selected card data for display
    //   setSelectedCard({
    //     voterId: response.data.data.input_voter_id,
    //     name: response.data.data.name,
    //     fatherName: response.data.data.relation_name,
    //     dob: response.data.data.dob || "N/A",
    //     address:
    //       response.data.data.house_no +
    //         " " +
    //         response.data.data.area +
    //         " " +
    //         response.data.data.district +
    //         " " +
    //         response.data.data.state || "N/A",
    //     photoUrl: img,
    //   });
    // } catch (err) {
    //   console.error("Error fetching Voter data:", err);
    //   let errorMessage = "Failed to fetch Voter data. Please try again.";

    //   toast.error(errorMessage);

    //   // Add failed attempt to history
    //   const newEntry = {
    //     date: new Date().toLocaleString(),
    //     voterId,
    //     name: "N/A",
    //     dob: "N/A",
    //     status: "Failed",
    //     error: errorMessage,
    //   };
    //   setHistory((prev) => [newEntry, ...prev]);
    // } finally {
    //   setIsLoading(false);
    // }

    // try {
    //   await new Promise((resolve) => setTimeout(resolve, 500));

    //   const response = {
    //     data: {
    //       success: true,
    //       message: "Mock voter ID verification success",
    //       data: {
    //         ...mockVoterData,
    //         input_voter_id: voterId,
    //         name: "VISHAL KUMAR",
    //         relation_name: "RAJENDRA SINGH",
    //         dob: "01/01/2000",
    //         house_no: "123",
    //         area: "Test Area",
    //         district: "Test District",
    //         state: "Test State",
    //         photoUrl: uploadedImageUrl || img,
    //       },
    //     },
    //   };

    //   const data = response.data.data;

    //   setVoterData(data);
    //   setShowCard(true);

    //   const newEntry = {
    //     date: new Date().toLocaleString(),
    //     voterId: data.input_voter_id,
    //     name: data.name,
    //     dob: data.dob,
    //     status: "Success",
    //   };
    //   setHistory((prev) => [newEntry, ...prev]);

    //   // ✅ Only set selectedCard *after* confirmation and mock API call
    //   setSelectedCard({
    //     voterId: data.input_voter_id,
    //     name: data.name,
    //     fatherName: data.relation_name,
    //     dob: data.dob || "N/A",
    //     address: `${data.house_no} ${data.area} ${data.district} ${data.state}`,
    //     photoUrl: uploadedImageUrl,
    //   });

    //   toast.success("Voter data fetched successfully");
    // } catch (err) {
    //   console.error("Error:", err);
    //   toast.error("Failed to fetch voter data. Try again.");
    // } finally {
    //   setIsLoading(false);
    // }

    //! BYPASS: Use mockVoterData for testing  Siddant Bhai code
    // try {
    //   // Simulate API delay
    //   await new Promise((resolve) => setTimeout(resolve, 500));
    //   const response = {
    //     data: {
    //       success: true,
    //       message: "Voter ID verification successful (using mock data)",
    //       data: {
    //         ...mockVoterData,
    //         input_voter_id: voterId,
    //         name: "VISHAL KUMAR",
    //         relation_name: "RAJENDRA SINGH",
    //         dob: "01/01/2000",
    //         house_no: "123",
    //         area: "Test Area",
    //         district: "Test District",
    //         state: "Test State",
    //         photoUrl: img,
    //       },
    //     },
    //   };

    //   setVoterData(response.data.data);
    //   setShowCard(true);

    //   // Add to history
    //   const newEntry = {
    //     date: new Date().toLocaleString(),
    //     voterId: response.data.data.input_voter_id,
    //     name: response.data.data.name || "N/A",
    //     dob: response.data.data.dob || "N/A",
    //     status: "Success",
    //   };
    //   setHistory((prev) => [newEntry, ...prev]);

    //   toast.success("Voter data fetched successfully (using mock data)");
    //   // Set the selected card data for display
    //   setSelectedCard({
    //     voterId: response.data.data.input_voter_id,
    //     name: response.data.data.name,
    //     fatherName: response.data.data.relation_name,
    //     dob: response.data.data.dob || "N/A",
    //     address:
    //       response.data.data.house_no +
    //         " " +
    //         response.data.data.area +
    //         " " +
    //         response.data.data.district +
    //         " " +
    //         response.data.data.state || "N/A",
    //     photoUrl: img,
    //   });
    // } catch (err) {
    //   console.error("Error fetching Voter data:", err);
    //   let errorMessage = "Failed to fetch Voter data. Please try again.";
    //   toast.error(errorMessage);
    //   // Add failed attempt to history
    //   const newEntry = {
    //     date: new Date().toLocaleString(),
    //     voterId,
    //     name: "N/A",
    //     dob: "N/A",
    //     status: "Failed",
    //     error: errorMessage,
    //   };
    //   setHistory((prev) => [newEntry, ...prev]);
    // } finally {
    //   setIsLoading(false);
    // }

    // REAL API CALL (commented out for testing)
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/services/voter/voter-id-verification`,
        {
          id_number: voterId,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        },
      );

      if (response.data.success === false) {
        throw new Error(
          response.data.message || "Failed to fetch Voter ID data",
        );
      }

      // setVoterData(response.data.data);
      // setShowCard(true);

      const data = response.data.data;

      setVoterData(data);
      setShowCard(true);

      const newEntry = {
        date: new Date().toLocaleString(),
        voterId: data.input_voter_id,
        name: data.name,
        dob: data.dob,
        status: "Success",
      };
      setHistory((prev) => [newEntry, ...prev]);

      // ✅ Only set selectedCard *after* confirmation and mock API call
      // setSelectedCard({
      //   voterId: data.input_voter_id,
      //   name: data.name,
      //   fatherName: data.relation_name,
      //   dob: data.dob || "N/A",
      //   address: `${data.house_no} ${data.area} ${data.district} ${data.state}`,
      //   photoUrl: uploadedImageUrl,
      // });

      toast.success("Voter data fetched successfully");
      // Set the selected card data for display
      setSelectedCard({
        // voterId: data.input_voter_id,
        // name: data.name,
        // fatherName: data.relation_name,
        // dob: data.dob  ,
        // address:
        //   data.house_no +
        //     " " +
        //     data.area +
        //     " " +
        //     data.district +
        //     " " +
        //     data.state ,
        ...data,
        photoUrl: uploadedImageUrl,
      });
    } catch (err) {
      console.error("Error fetching Voter data:", err);
      let errorMessage = "Failed to fetch Voter data. Please try again.";
      if (err.response) {
        if (err.response.data && err.response.data.message) {
          errorMessage = err.response.data.message;
        } else if (err.response.status === 401) {
          errorMessage = "Unauthorized - Please login again";
        } else if (err.response.status === 403) {
          errorMessage = "Forbidden - You don't have permission";
        } else if (err.response.status === 404) {
          errorMessage = "Service not found";
        } else if (err.response.status === 500) {
          errorMessage = "Server error - Please try again later";
        }
      } else if (err.request) {
        errorMessage = "Network error - Please check your connection";
      }

      toast.error(errorMessage);

      // Add failed attempt to history
      const newEntry = {
        date: new Date().toLocaleString(),
        voterId,
        name: "N/A",
        dob: "N/A",
        status: "Failed",
        error: errorMessage,
      };
      setHistory((prev) => [newEntry, ...prev]);
    } finally {
      setIsLoading(false);
    }
  };

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedFile(file);
    }
  };

  const handleSubmit = async () => {
    if (!voterId.trim()) {
      toast.error("Please enter Voter ID number");
      return;
    }

    if (!selectedFile) {
      toast.error("Please upload a photo first");
      return;
    }

    try {
      setUploading(true);
      const formData = new FormData();
      formData.append("file", selectedFile);
      formData.append("upload_preset", REACT_APP_CLOUDINARY_UPLOAD_PRESET);

      const res = await axios.post(REACT_APP_CLOUDINARY_UPLOAD_URL, formData);
      const imageUrl = res.data.secure_url;
      setUploadedImageUrl(imageUrl);
      toast.success("Image uploaded successfully!");

      setShowConfirmationModal(true);
    } catch (error) {
      console.error("Image upload failed:", error);
      toast.error("Image upload failed. Please try again.");
    } finally {
      setUploading(false);
    }
  };

  const generateVoterHTML = (selectedCard) => {
    return "";
  };

  const GenerateVoterPDF = (selectedCard) => {
    const htmlContent = generateVoterHTML(selectedCard);

    const options = {
      margin: 0,
      filename: `VOTER-${selectedCard?.voterId || "Card"}.pdf`,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: {
        scale: 2,
        useCORS: true,
        scrollX: 0,
        scrollY: 0,
      },
      jsPDF: {
        unit: "mm",
        format: "a4",
        orientation: "portrait",
      },
    };

    html2pdf().set(options).from(htmlContent).save();
  };

  const handleDownloadPDF = async () => {
    if (!assetsReady) {
      toast.warning("Please wait, card templates are still preloading...");
      return;
    }

    if (!printRef.current || !selectedCard) {
      toast.error("Nothing to download");
      return;
    }

    try {
      setIsLoading(true);

      const canvas = await html2canvas(printRef.current, {
        scale: 2,
        useCORS: true,
        backgroundColor: "#ffffff",
      });

      const imgData = canvas.toDataURL("image/png");

      const pdf = new jsPDF("portrait", "pt", "a4");
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();

      const ratio = Math.min(
        pageWidth / canvas.width,
        pageHeight / canvas.height,
      );
      const imgWidth = canvas.width * ratio;
      const imgHeight = canvas.height * ratio;

      const marginX = (pageWidth - imgWidth) / 2;
      const marginY = 30;

      pdf.addImage(imgData, "PNG", marginX, marginY, imgWidth, imgHeight);
      pdf.save(`VOTER-${selectedCard.voterId || "Card"}.pdf`);

      toast.success("PDF downloaded");
    } catch (error) {
      console.error("Error generating PDF:", error);
      toast.error("Failed to generate PDF.");
    } finally {
      setIsLoading(false);
    }
  };

  const totalPages = Math.ceil(filteredHistory.length / itemsPerPage);
  const currentData = filteredHistory.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage,
  );
  const handlePrev = () => setCurrentPage((prev) => Math.max(prev - 1, 1));
  const handleNext = () =>
    setCurrentPage((prev) => Math.min(prev + 1, totalPages));
  const visiblePages = useMemo(() => {
    const delta = 2; // how many pages around current
    const pages = [];
    for (
      let i = Math.max(1, currentPage - delta);
      i <= Math.min(totalPages, currentPage + delta);
      i++
    ) {
      pages.push(i);
    }
    return pages;
  }, [currentPage, totalPages]);
  return (
    <div className="py-4 w-full">
      <div className="bg-blue-100 p-2 mb-4">
        <h2 className="text-center text-xl font-semibold text-blue-700">
          Download Voter ID Card
        </h2>
      </div>

      <div className="py-4 space-y-4">
        <div className="flex flex-row gap-4">
          {/* Voter ID Input */}
          <input
            type="text"
            placeholder="Enter Voter ID"
            value={voterId}
            onChange={(e) => setVoterId(e.target.value.toUpperCase())}
            className="px-4 py-2 border border-gray-300 rounded-md w-1/2"
          />
          {/* File Upload */}
          <input
            type="file"
            accept="image/*"
            onChange={handleFileUpload}
            className="block w-1/2 text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-md file:border-0 file:text-sm file:font-semibold file:bg-indigo-50 file:text-indigo-700 hover:file:bg-indigo-100"
          />
        </div>
        {/* Submit Button */}
        <button
          onClick={handleSubmit}
          disabled={isLoading || !voterId}
          className={`bg-indigo-600 text-white py-2 px-6 rounded hover:bg-indigo-700 ${
            isLoading ? "opacity-70 cursor-not-allowed" : ""
          }`}
        >
          {isLoading ? "Processing..." : "SUBMIT"}
        </button>
      </div>

      <div className="w-full">
        <div className="bg-white p-4 shadow-md rounded-lg mb-4">
          <h3 className="text-lg font-semibold mb-4">Voter Results</h3>

          <div className="bg-gray-50 p-4 rounded-lg mb-4">
            <h4 className="text-md font-medium mb-3">Filter Current Results</h4>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-4">
              <div>
                <label className="block text-sm font-medium mb-1">Search</label>
                <input
                  type="text"
                  placeholder="Search Voter number"
                  value={filters.search}
                  onChange={(e) =>
                    setFilters({ ...filters, search: e.target.value })
                  }
                  className="w-full border border-gray-300 rounded px-3 py-2"
                />
              </div>
              <div>
                <label className="block text-sm font-medium mb-1">Status</label>
                <select
                  value={filters.status}
                  onChange={(e) =>
                    setFilters({ ...filters, status: e.target.value })
                  }
                  className="w-full border rounded px-3 py-2"
                >
                  <option value="">All Status</option>
                  <option value="Success">Success</option>
                  <option value="Failed">Failed</option>
                  <option value="pending">Pending</option>
                </select>
              </div>
              <div>
                <label className="block text-sm font-medium mb-1">
                  From Date
                </label>
                <input
                  type="date"
                  value={filters.fromDate}
                  onChange={(e) =>
                    setFilters({ ...filters, fromDate: e.target.value })
                  }
                  className="w-full border rounded px-3 py-2"
                />
              </div>
              <div>
                <label className="block text-sm font-medium mb-1">
                  To Date
                </label>
                <input
                  type="date"
                  value={filters.toDate}
                  onChange={(e) =>
                    setFilters({ ...filters, toDate: e.target.value })
                  }
                  className="w-full border rounded px-3 py-2"
                />
              </div>
            </div>

            <div className="flex justify-end gap-2">
              <button
                onClick={clearFilters}
                className="px-4 py-2 bg-gray-200 rounded hover:bg-gray-300"
              >
                Clear
              </button>
              <button
                onClick={applyFilters}
                className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
              >
                Apply
              </button>
            </div>
          </div>
          <div className="bg-white shadow rounded-lg overflow-x-auto">
            <table className="min-w-full text-sm text-left">
              <thead className="bg-gray-100 text-gray-700">
                <tr>
                  <th className="px-4 py-2">Sl No</th>
                  <th className="px-4 py-2">Date & Time</th>
                  <th className="px-4 py-2">Voter ID</th>
                  {/* <th className="px-4 py-2">Name</th> */}
                  {/* <th className="px-4 py-2">DOB</th> */}
                  <th className="px-4 py-2">Status</th>
                  {/* <th className="px-4 py-2">Action</th> */}
                </tr>
              </thead>
              <tbody>
                {currentData.length > 0 ? (
                  currentData.map((item, idx) => (
                    <tr key={idx} className="border-t hover:bg-gray-50">
                      <td className="px-4 py-2">
                        {(currentPage - 1) * itemsPerPage + idx + 1}
                      </td>
                      <td className="px-4 py-2">{item.date}</td>
                      <td className="px-4 py-2 font-mono">{item.voterId}</td>
                      {/* <td className="px-4 py-2">{item.name}</td> */}
                      {/* <td className="px-4 py-2">{item.dob}</td> */}
                      <td className="px-4 py-2">
                        <span
                          className={`px-2 py-1 rounded text-white text-xs ${
                            item.status === "Success"
                              ? "bg-green-500"
                              : "bg-red-500"
                          }`}
                        >
                          {item.status}
                        </span>
                      </td>
                      {/* <td className="px-4 py-2">
              {item.status === "Success" && (
                <button 
                  onClick={() => {
                    setSelectedCard({
                      voterId: item.voterId,
                      name: item.name,
                      fatherName: "N/A",
                      dob: item.dob,
                      address: "N/A",
                      photoUrl: img
                    });
                  }}
                  className="text-blue-600 hover:text-blue-800"
                >
                  <BsFiletypePdf className="inline" />
                </button>
              )}
            </td> */}
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan="7"
                      className="px-4 py-4 text-center text-gray-500"
                    >
                      No records found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          <div className="flex flex-col md:flex-row items-center justify-between mt-4">
            <span className="text-sm text-gray-500">
              Showing {(currentPage - 1) * itemsPerPage + 1} to{" "}
              {Math.min(currentPage * itemsPerPage, filteredHistory.length)} of{" "}
              {filteredHistory.length} entries
            </span>

            <div className="flex gap-2 mt-2 md:mt-0">
              <button
                onClick={handlePrev}
                disabled={currentPage === 1}
                className="px-3 py-1 border rounded text-sm disabled:opacity-50"
              >
                Prev
              </button>

              {visiblePages[0] > 1 && <span className="px-2">...</span>}
              {visiblePages.map((p) => (
                <button
                  key={p}
                  onClick={() => setCurrentPage(p)}
                  className={`px-3 py-1 border rounded text-sm ${
                    currentPage === p ? "bg-blue-600 text-white" : ""
                  }`}
                >
                  {p}
                </button>
              ))}
              {visiblePages[visiblePages.length - 1] < totalPages && (
                <span className="px-2">...</span>
              )}

              <button
                onClick={handleNext}
                disabled={currentPage === totalPages}
                className="px-3 py-1 border rounded text-sm disabled:opacity-50"
              >
                Next
              </button>
            </div>
          </div>
          {showConfirmationModal && (
            <PortalModal>
              <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
                <div className="bg-white rounded-lg shadow-lg w-full max-w-md p-6">
                  <h3 className="text-lg font-semibold mb-4">
                    Confirm Payment
                  </h3>
                  <p className="mb-4">
                    This Voter ID verification will cost you{" "}
                    <span className="text-red-600"> ₹{voterIdPrice} </span>. Do
                    you want to proceed?
                  </p>
                  <div className="flex justify-end gap-4">
                    <button
                      onClick={() => setShowConfirmationModal(false)}
                      className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400"
                    >
                      Cancel
                    </button>
                    <button
                      onClick={() => {
                        setShowConfirmationModal(false);
                        proceedWithApiCall();
                      }}
                      className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
                    >
                      Confirm & Pay
                    </button>
                  </div>
                </div>
              </div>
            </PortalModal>
          )}
          {selectedCard && (
            <PortalModal>
              <div className="fixed inset-0 z-50 bg-black bg-opacity-50 flex items-center justify-center">
                <div className="bg-white rounded-lg shadow-lg p-4">
                  <div
                    id="printVoterArea"
                    ref={printRef}
                    className="flex flex-col md:flex-row gap-4"
                  >
                    {/* Front Side */}
                    <div
                      className="w-[360px] h-[220px] border rounded-xl overflow-hidden text-[10px] shadow px-2 py-2 flex flex-col justify-between bg-cover bg-center"
                      style={{ backgroundImage: `url(${assets.voter})` }}
                    >
                      <div className=" px-2 pt-1 pb-2 text-center ">
                        <div className="flex justify-between items-center">
                          <img src={assets.ashok1} alt="Emblem" className="w-10 h-10" />
                          <div className="text-[10px] font-bold">
                            <p>भारत निर्वाचन आयोग</p>
                            <p>ELECTION COMMISSION OF INDIA</p>
                          </div>
                          <img src={assets.voteLogo} alt="ECI" className="w-10 h-10" />
                        </div>
                      </div>
                      <div className="flex p-2 gap-2">
                        <div className="w-[70px] h-[90px] bg-gray-200 border">
                          <img
                            src={selectedCard?.photoUrl || uploadedImageUrl}
                            alt="User"
                            className="w-full h-full object-cover"
                          />
                        </div>
                        <div className="flex-1 text-gray-800 text-[10px] space-y-[2px]">
                          <p>
                            <strong>नाम / Name:</strong> {selectedCard.name}
                          </p>
                          <p>
                            <strong>पिता का नाम / Father's Name:</strong>{" "}
                            {selectedCard.fatherName}
                          </p>
                          <p>
                            <strong>लिंग / Gender:</strong> पुरुष / Male
                          </p>
                          <p>
                            <strong>जन्म तिथि / DOB:</strong> {selectedCard.dob}
                          </p>
                          <p>
                            <strong>EPIC No:</strong> {selectedCard.voterId}
                          </p>
                        </div>
                      </div>
                      <div className="text-center text-[8px] pt-2">
                        {/* <hr className="border-black mb-1" /> */}
                        <p>
                          {" "}
                          e-Electors Photo Identity Card - ई-मतदाता पहचान पत्र
                        </p>
                      </div>
                      {/* <div className="text-center text-[8px] pt-8 py-1">
                    <h1 className="p-2">
                     
                    </h1>
                  </div> */}
                    </div>

                    {/* Back Side */}
                    <div
                      className="w-[360px] h-[220px] border rounded-xl overflow-hidden text-[10px] shadow px-2 py-2 flex flex-col justify-between bg-cover bg-center"
                      style={{ backgroundImage: `url(${assets.voter})` }}
                    >
                      <div className="text-gray-700 text-[9px]">
                        <p className="font-semibold">पता / Address:</p>
                        <p className="whitespace-pre-wrap">
                          {selectedCard.address}
                        </p>
                      </div>
                      <div className="flex justify-end px-4 mt-2">
                        <QRCodeCanvas value={selectedCard.voterId} size={60} />
                      </div>
                      <div className="text-center text-[8px] pt-2">
                        {/* <hr className="border-black mb-1" /> */}
                        <p>Issued by Electoral Registration Officer (ERO)</p>
                      </div>
                    </div>
                  </div>

                  {selectedCard && (
                    <div
                      style={{
                        position: "absolute",
                        top: "-9999px",
                        left: "-9999px",
                        width: "842pt",
                        height: "595pt",
                        backgroundColor: "#ffffff",
                        padding: "20pt",
                      }}
                      ref={printRef}
                    >
                      <VoterIDCard selectedCard={selectedCard} />
                    </div>
                  )}

                  <div className="mt-4 flex justify-between">
                    <button
                      onClick={() => setSelectedCard(null)}
                      className="bg-gray-300 px-4 py-1 rounded hover:bg-gray-400"
                      disabled={isDownloading}
                    >
                      Close
                    </button>

                     <button
                      onClick={handleDownloadPDF}
                      disabled={isDownloading || !assetsReady}
                      className={`px-4 py-1 rounded text-white ${
                        isDownloading || !assetsReady
                          ? "bg-blue-400 cursor-not-allowed"
                          : "bg-blue-600 hover:bg-blue-700"
                      }`}
                    >
                      {isDownloading ? "Downloading..." : !assetsReady ? "Loading Templates..." : "Download PDF"}
                    </button>
                  </div>
                </div>
              </div>
            </PortalModal>
          )}
        </div>
      </div>
    </div>
  );
}
